import fecha from './date';
export default {
    isDate(date) {
        if (date === null || date === undefined) return false;
        if (isNaN(new Date(date).getTime())) return false;
        return true;
    },
    toDate(date) {
        return this.isDate(date) ? new Date(date) : null;
    },
    // 时间转换
    timeCycle(date, format) {
        /* 
            格式	含义	备注	举例
            yyyy	年		        2017
            M	    月	    不补0	1
            MM	    月		        01
            d	    日	    不补0	2
            dd	    日		        02
            H	    小时	不补0	3
            HH	    小时	    	03
            m	    分钟	不补0	4
            mm	    分钟		    04
            s	    秒	    不补0	5
            ss	    秒		        05 
        */
        date = this.toDate(date);
        if (!date) return '';
        return fecha.format(date, format || 'default');
    },
    addCommas(num) {
        let numStr = num.toString();
        return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    fileDow(file, fileName) {
        let fileStream = new Blob([file], {
            type: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        // 创建一个下载链接
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(fileStream);
        downloadLink.download = fileName + '.xls';

        // 将下载链接添加到页面中并模拟点击
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // 清理下载链接
        URL.revokeObjectURL(downloadLink.href);
        document.body.removeChild(downloadLink);
    }
}